import { initialValues } from '~checkout/components/Purchaser/schema';

/**
 * Address Store
 * ----------------------------
 *
 *
 */
export const useAddressStore = defineStore('address', () => {
    const { products } = storeToRefs(useCartStore());

    /**
     * Purchaser
     * ------------------------------------------------------------------------------------------
     */
    const purchaser = ref<Purchaser>(deepClone(initialValues));

    const hasPurchaser = computed(() => {
        return !Object.values(purchaser.value).every((value) => {
            if (value !== null && typeof value === 'object') {
                return Object.values(value).every(nestedValue => nestedValue === '');
            }
            return value === '' || value === undefined || value === null;
        });
    });

    /**
     * If any of the offers requires the phone number of the purchaser
     * This is used to determine if the phone number field should be shown in the purchaser dialog
     * ------------------------------------------------------------------------------------------
     */
    const isPurchaserPhoneNumberRequired = computed(() =>
        products.value.some(p => p.requiredPurchaserInformation?.phoneNumber.required),
    );

    /**
     * ------------------------------------------------------------------------------------------
     */

    function reset() {
        purchaser.value = deepClone(initialValues);
    }

    return {

        // Purchaser
        purchaser,
        hasPurchaser,
        isPurchaserPhoneNumberRequired,

        reset,
    };
}, {
    persist: {
        ...storePersist.storePersistOptions,
        key: 'address-v6',
    },
});
